<!--  -->
<template>
  <div>
    <el-button class="addbutton" type="primary" plain @click="addConfig">添加</el-button>
    <el-table
      border
      :cell-style="{'text-align':'center'}"
      :data="datas"
      style="width: 100%"
    >
      <el-table-column
        prop="type_str"
        label="类型"
        align="center"
        width="180"
      />
      <el-table-column
        label="请假频率"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          {{ scope.row.min_frequency }}<span style="margin: 5px;">---</span>{{ scope.row.max_frequency }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="user_str" label="人员配置">
        <template slot-scope="scope">
          <div class="column-content">
            <span v-for="item in scope.row.user_str" :key="item.id" class="name-item">{{ item.name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="状态">
        <template slot-scope="scope">
          <div style="position: relative; display: inline-block;">
            <el-switch
              v-model="scope.row.status"
              :width="50"
              active-color="#13ce66"
              inactive-color="rgb(191,191,191)"
              :active-value="1"
              :inactive-value="2"
              @change="changewr($event,scope.row)"
            />
            <div
              v-if="scope.row.status === 1"
              style="color: #fff;position: absolute;top: 2px;left: 7px;"
            >是</div>
            <div
              v-else
              style="color: #fff;position: absolute;top: 2px;right: 7px;"
            >否</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="mini"
            style="margin-bottom:10px"
            @click="deldata(scope.row)"
          >删除</el-button>
          <el-button
            type="primary"
            size="mini"
            style="margin-bottom:10px"

            @click="editdata(scope.row)"
          >修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :title="{ add: '添加', edit: '编辑' }[mode]"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="50%"
      @close="closeEvent"
    >
      <el-form ref="forms" :validate-on-rule-change="false" label-width="70px" style="width: 400px;" :model="forms">
        <el-form-item label="请假频率">
          <el-col :span="8">
            <el-form-item prop="2">
              <el-input v-model="forms.min_frequency" v-numericonly placeholder="请输入数字" />
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">
            <span style="margin: 8px;">--</span>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="0">
              <el-input v-model="forms.max_frequency" v-numericonly placeholder="请输入数字" />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item prop="type" label="类型">
          <el-select v-model="forms.type" :disabled="showload===false" style="width: 245px;" placeholder="选择类型">
            <el-option label="请假" value="1" />
            <el-option label="出差" value="2" />
            <el-option label="外出" value="3" />
            <el-option label="加班" value="4" />
          </el-select>
        </el-form-item>
      </el-form>
      <div class="select-box">
        <div>
          <el-checkbox v-model="fullName" style="margin-bottom:15px ;" @change="whole">全选</el-checkbox>
          <div class="checkbox-list">
            <div v-for="(item,index) in arr" :key="item.id" class="checkbox-item">
              <el-checkbox v-model="item.checked" @click.native.stop @change="itenclick(item,index)">{{ item.label }}</el-checkbox>
            </div>
          </div>
        </div>
        <div style="display:flex;" class="selected-box">
          <div class="vertical-line" />
          <div>
            <div>
              <div style="margin-bottom:15px ;">选中的员工</div>
              <el-tag
                v-for="(tag,index) in arrs"
                :key="tag.user_id"
                closable
                style="margin-right:10px;margin-bottom:5px"
                :type="tag.type"
                @close="rightclick(tag.user_id,index)"
              >
                {{ tag.name }}
              </el-tag>
            </div>
          </div>
        </div>
      </div>

      <pagination-right
        style="padding:0px;margin-top:20px"
        :total="total"
        :current-page="obr.page"
        :page-size="obr.pageSize"
        :page-sizes="[10, 50, 100]"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
      <div class="que_box">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { spCorpcorpUsersList } from '@/api/officialaccount.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { spWorkWechatSpCorpOaConfigIndex, spWorkWechatSpCorpOaConfigAdd, spWorkWechatSpCorpOaConfigUpdate, spWorkWechatSpCorpOaConfigDel, spWorkWechatSpCorpOaConfigSetStatus } from '@/api/reportExamine.js'
import convertToHump from '@/utils/mixins/convertToHump.js'

export default {

  components: { PaginationRight },
  directives: {
    numericonly: {
      bind: function(el) {
        // console.log(11)
        el.addEventListener('input', function(e) {
          if (/\D/.test(e.target.value)) {
            e.target.value = e.target.value.replace(/\D/g, '')
          }
        })
      }
    }
  },
  mixins: [convertToHump],
  data() {
    return {
      userids: [],
      showload: true,
      mode: '',
      value1: [], // 公众号多选完成集合数组
      id: null, // 点击保存的id
      arr: [],
      arrs: [],
      arrsw: [],
      datas: [],
      forms: {
        min_frequency: '', // 最小频率
        max_frequency: '', // 最大频率
        user: '', // 选择的员工，多个逗号隔开
        type: '', // 类型 1-请假；2-出差；3-外出；4-加班
        corp_primary_id: '', // 企业主键id
        status: ''
      },
      obr: {
        user_id: null,
        name: null,
        sp_strategy_no: null,
        page: 1,
        pageSize: 50,
        corp_id: null,
        keywords: null
      },
      total: null,
      dialogVisible: false
    }
  },
  computed: {
    fullName: {
      get() {
        return this.arr.every(item => item.checked)
      },
      set(value) {
        this.arr.forEach(item => {
          item.checked = value
        })
      }
    }
  },
  created() {
  },
  mounted() {
    this.list()
    this.getdatalist()
  },
  activated() {
    this.getdatalist()
  },
  // 全选
  methods: {
    whole(e) {
      if (!e) {
        // console.log('666')
        let index = ''
        this.arr.forEach((item) => {
          if (item.checked === false) {
            index = this.arrs.findIndex((items) => {
              return items.user_id === item.user_id
            })
          }
          this.arrs.splice(index, 1)
          this.userids.splice(index, 1)
        }
        )
      } else {
        this.arr.forEach((item) => {
          // console.log(item)
          if (item.checked === true) {
            this.arrs.map(re => re.user_id).includes(item.user_id) || this.arrs.push({ user_id: item.user_id, name: item.label, id: item.id })
          }
        })
      }
      this.forms.user = [...new Set(this.arrs.map(item => item.id))]
      console.log(this.forms.user, '全选')
    },
    // 点击单选
    itenclick(item, index) {
      if (item.checked === true) {
        this.arrs.push({ user_id: item.user_id, name: item.label, id: item.id })
      } else {
        const index = this.arrs.findIndex(v => v.user_id === item.user_id)
        if (index !== -1) {
          this.arrs.splice(index, 1)
        }
      }
      this.forms.user = [...new Set(this.arrs.map(item => item.id))]
      console.log(this.forms.user, this.arrs, ' 单选this.forms.user')
    },
    // 选中员工删除
    rightclick(user_id, index) {
      console.log(user_id, index, 'user_id, index')
      this.arrs.splice(index, 1)
      this.arr.findIndex((items) => {
        if (items.user_id === user_id) {
          items.checked = false
        }
      })
      this.forms.user = [...new Set(this.arrs.map(item => item.id))]
      console.log(this.forms.user, '删除this.forms.user')
    },
    async list(userid, type, newarr) {
      this.obr.corp_id = this.$route.query.chatid
      const data = await spCorpcorpUsersList(this.obr)
      this.arr = data.data.list.map(item => {
        return {
          id: item.employee_no,
          label: item.name,
          checked: false,
          user_id: item.user_id
        }
      })
      this.total = data.data.total
      if (this.arrs.length > 0) {
        // console.log(11222, this.arrs, this.arr)
        if (this.mode === 'add') {
          this.arrs.forEach(item => {
            this.arr.forEach((items) => {
              if (item.user_id === items.user_id) {
                items.checked = true
              }
            })
          })
        } else {
          // console.log('type---2', this.userids)
          this.arrs.forEach(item => {
            this.arr.forEach((items) => {
              if (item.user_id === items.user_id) {
                items.checked = true
              }
            })
          })
        }
      }
      // const ids = []
      if (type === 2) {
        this.arrs = []
        newarr.filter(item => {
          this.arrs.push({
            name: item.name,
            user_id: item.user_id,
            id: item.id
          })
          // ids.push(item.id)
          this.arr.forEach(items => {
            if (items.user_id === item.user_id) {
              items.checked = true
            }
          })
        })
        this.userids = newarr
        // this.forms.user = ids
        this.forms.user = [...new Set(this.arrs.map(item => item.id))]
        console.log(' this.forms.user:这个是list', this.forms.user)
      }
    },
    // 页面展示数据
    async getdatalist() {
      const res = await spWorkWechatSpCorpOaConfigIndex(this.$route.query.corp_id)
      this.datas = res.data.list
    },
    // 点击确定
    async submit() {
      this.forms.corp_primary_id = this.$route.query.corp_id
      const { min_frequency, max_frequency } = this.forms
      if (this.arrs.length === 0) {
        this.$message.error('请选择要绑定的员工')
        return
      } if (this.forms.type === '') {
        this.$message.error('请选择请假类型')
        return
      }
      if (this.forms.min_frequency >= this.forms.max_frequency && this.forms.min_frequency !== '' && this.forms.max_frequency !== '') {
        this.$message.error('最小值不能大于等于最大值,也不能为空')
        return
      }
      let user = ''
      if (!Array.isArray(this.forms.user)) {
        const arr = this.forms.user.split(',')
        user = [...new Set(arr)].join(',')
      } else {
        user = [...new Set(this.forms.user)].join(',')
      }
      if (this.mode === 'add') {
        this.forms.user = user
        await spWorkWechatSpCorpOaConfigAdd(this.forms)
      } else if (this.mode === 'edit') {
        await spWorkWechatSpCorpOaConfigUpdate({
          corp_primary_id: this.forms.corp_primary_id,
          id: this.forms.id,
          user,
          min_frequency,
          max_frequency
        })
      }
      this.$message({
        message: this.mode === 'add' ? '添加成功' : '修改成功',
        type: 'success'
      })
      this.getdatalist()
      this.dialogVisible = false
    },

    editdata(row) {
      console.log('row:', row)
      this.forms.type = ''
      this.forms.type = String(row.type)
      this.dialogVisible = true
      this.forms.max_frequency = row.max_frequency
      this.forms.min_frequency = row.min_frequency
      this.forms.id = row.id
      this.showload = false
      this.mode = 'edit'
      const arr = Object.assign({}, row)
      const copy = [arr]
      copy.map(item => {
        const userid = JSON.parse(`[${row.user.split(',').map(id => `"${id}"`)}]`)
        const newarr = Object.values(row.user_str).map(item => {
          return {
            name: item.name,
            id: item.employee_no,
            user_id: item.user_id
          }
        })
        this.list(userid, 2, newarr)
      })
    },

    async  deldata(row) {
      this.$confirm('您确定删除吗')
        .then(async() => {
          await spWorkWechatSpCorpOaConfigDel({ id: row.id })
          this.getdatalist()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
        })
        .catch(() => {})
    },

    async changewr(e, item) {
      await spWorkWechatSpCorpOaConfigSetStatus({
        id: item.id,
        status: e
      })
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.getdatalist()
    },

    // 分页
    fetchPageSize(e) {
      this.obr.pageSize = e
      this.obr.page = 1
      this.list()
    },
    fetchCurrentPage(e) {
      this.obr.page = e
      this.list()
    },
    set(id) {
      this.arrs.forEach((item) => {
        if (item.user_id === id) {
          item.tips = false
        }
      })
    },
    addConfig() {
      this.list()
      this.getdatalist()
      this.dialogVisible = true
      this.showload = true
      this.mode = 'add'
    },
    // 重置表单
    closeEvent() {
      // 清空表单数据
      this.$refs.forms.resetFields()
      this.forms = {
        min_frequency: '', // 最小频率
        max_frequency: '', // 最大频率
        user: '', // 选择的员工，多个逗号隔开
        type: '', // 类型 1-请假；2-出差；3-外出；4-加班
        corp_primary_id: '', // 企业主键id
        status: ''
      }
      this.arr = []
      this.arrs = []
      this.loadingedit = false
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.allbox{
  padding: 30px;
}
.que_box{
  margin-top: 20px;
}
.have{
  color: #409eff;
}
.serch_box{
  display: flex;
  margin-bottom: 10px;
}
.search_icon{
  margin-left: 10px;
}
.band_box{
  display: flex;
}
.choses_box{
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.select_box{
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
/* .select_boxone{
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-right: 7px;
  background-color: #ccc;
} */
.choose_block{
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 10px;
}
.choose_blockr{
  background: #409eff;
}
.rigboxr{
  margin-left: 85px;
  border-left: 1px solid #ccc;
  padding-left: 30px;
  max-height: 520px;
  overflow: hidden;
  overflow-y: scroll;
}
:-webkit-scrollbar {
     width: 0 !important;
}
::-webkit-scrollbar {
     width: 0 !important;height: 0;
  }
.choiceofficialaccount{
  margin-bottom: 10px;
}
.select_spacing{
  margin-bottom: 5px;
}
.choose_allblock{
  height: 370px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.addbutton{
margin-bottom: 20px;
}
.name-container {
  /* display: flex; */
}
.vertical-line {
  border-left: 1px solid #ccc;
  height: 320px; /* 设置线条的高度 */
  margin-right: 15px;
}

.name-item {
  margin-right: 10px;
}
.checkbox-list {
  display: flex;
  flex-direction: column;
}

.checkbox-item {
  margin-bottom: 5px;
}
.checkbox-list[data-v-7c3d2f28] {
   width: 300px;
    flex-wrap: wrap;
    max-height: 300px;
    overflow-y: auto;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #438ff7; /* 设置背景颜色为透明 */
  border-color: #438ff7; /* 设置边框颜色为透明 */
}

.el-checkbox__input.is-checked  .el-checkbox__inner {
  border: 1px solid #84cef3;
}
.column-content {
  display: flex;
  justify-content: center;
  flex-wrap:wrap;
  padding:0 20px;
  max-height: 200px; /* 设置容器最大高度 */
  overflow-y: auto; /* 启用垂直滚动条 */
}
.select-box{
  display:flex;
  margin-left: 70px;
}
@media (max-width: 768px){
  .select-box{
    flex-direction:column;
    margin:0px !important;
  }
  .selected-box{
    margin-top:5vw;
  }
  .el-select{
    width:auto !important;
  }
  .el-input--medium .el-input__inner{
    width:40vw !important;
  }
}
</style>
